import { useRipple } from "@songmg/react-use-ripple";
import React, { FC, Fragment, ReactNode, useRef, useState } from "react";
import styled from "styled-components";
import PulseLoader from "react-spinners/PulseLoader";

interface ButtonSecondaryWrapperProps {
	margin?: number;
	isLoading?: boolean;
}

const ButtonSecondaryWrapper = styled.button<ButtonSecondaryWrapperProps>`
	background: ${props => (props.isLoading ? "#cccccc" : props.theme.colors.primary)};
	box-shadow: 0px 4px 39px 6px rgba(0, 0, 0, 0.07);
	border-radius: 8px;
	font-family: Livvic;
	font-style: normal;
	font-weight: 600;
	font-size: 13px;
	line-height: 165.5%;
	color: ${props => (props.theme.colors.whiteVitat || "#002b49")};
	height: 26px;
	padding-left: 12px;
	padding-right: 12px;
	display: flex;
	flex-direction: row;
	flex-wrap: nowrap;
	justify-content: center;
	align-items: center;
	align-content: flex-start;
	gap: 8px;
	border: none;
	margin-top: ${props => props.margin ?? 0}px;
	margin-bottom: ${props => props.margin ?? 0}px;
`;

interface ButtonSecondaryProps {
	label?: string;
	icon?: ReactNode;
	onClick?: () => void;
	margin?: number;
	type?: "button" | "reset" | "submit" | undefined;
}

const ButtonSecondary: FC<ButtonSecondaryProps> = ({ icon, label, onClick, margin, type }) => {
	const ref = useRef() as React.MutableRefObject<HTMLButtonElement>;
	useRipple(ref, {
		rippleColor: "#cccccc",
		rippleSize: 300,
		animationLength: 200,
		endScale: 20,
	});
	const [isLoading, setIsLoading] = useState<boolean>(false);

	return (
		<ButtonSecondaryWrapper
			margin={margin}
			type={type}
			ref={ref}
			isLoading={isLoading}
			onClick={
				!isLoading
					? async () => {
							if (onClick) {
								setIsLoading(true);
								await onClick();
								setIsLoading(false);
							}
					  }
					: undefined
			}
		>
			{isLoading ? (
				<PulseLoader color={"#FFFFFF"} loading size={5} />
			) : (
				<Fragment>
					{icon}
					{label}
				</Fragment>
			)}
		</ButtonSecondaryWrapper>
	);
};

export default ButtonSecondary;
